import { render, staticRenderFns } from "./ModalPostAssessmentPromotion.vue?vue&type=template&id=0a98ce1a&scoped=true&"
import script from "./ModalPostAssessmentPromotion.vue?vue&type=script&lang=js&"
export * from "./ModalPostAssessmentPromotion.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/modal_post_assessment_promotion.scss?vue&type=style&index=0&id=0a98ce1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98ce1a",
  null
  
)

export default component.exports